const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB");
};

const formatWeekDifference = (stat) => {
  if (!stat || stat.current == null || stat.previous == null)
    return "Nothing to compare";
  if (!stat.successfulComparison) return "No data for comparison yet";

  const diff = stat.current - stat.previous;

  if (diff === 0) return "No change since last week";
  const sign = diff > 0 ? "+" : "";
  return `${sign}${diff} since last week`;
};

const calculateProgressPercent = (stat) => {
  if (!stat || stat.current == null || stat.target == null || stat.target === 0)
    return 0;

  return Math.round((stat.current / stat.target) * 100);
};

const getWeekDiffColor = (stat) => {
  if (!stat?.successfulComparison) return "text.secondary";
  if (stat?.current > stat?.previous) return "success.main";
  if (stat?.current < stat?.previous) return "error.main";
  return "text.secondary";
};

const formatProgressFraction = (stat) => {
  if (!stat || stat.current == null || stat.target == null) return "";
  return `${stat.current} / ${stat.target}`;
};

function formatUsageCount(count) {
  return `Used ${count} ${count === 1 ? "time" : "times"}`;
}

export {
  formatUsageCount,
  formatDate,
  formatWeekDifference,
  calculateProgressPercent,
  getWeekDiffColor,
  formatProgressFraction,
};
